export default __webpack_public_path__ + "static/media/img-app-discover-1.0dd88a6e.png";